<div class="bg" animate.enter="entering">
    <div class="home-container">
        <div class="headline">
            <div class="text_container">
                <h1 class="header">The art of looking at ourselves.</h1>
        </div>
        </div>
        <div class="content">
            <app-content-card>
                <app-back-button [color]="Color"></app-back-button>
                <div class="img-container">
                    <img src="../../../assets/projects/Volkstheater/nvt-logo.png" width="80%">
                </div>
                <app-about-volkstheater class="accent"></app-about-volkstheater>
                <h2 class="accent">tags.</h2>
                <app-chip [chips]="chips" class="accent bg"></app-chip>
                <app-links class="accent" Instagram={{Instagram}} Web={{Web}} Facebook={{Facebook}}></app-links>
                <app-footer class="accent"></app-footer>
            </app-content-card>
        </div>
    </div>
</div>